import Box from '@mui/material/Box'

const getServiceStatus = (service) => {
  if (service.currentStatuses && service.currentStatuses.length > 0) {
    return service.currentStatuses[0].state
  }
  return 'unknown'
}

const countServicesByStatus = (services) => {
  let running = 0
  let stopped = 0
  let other = 0

  services.forEach((service) => {
    const status = getServiceStatus(service)
    if (status === 'running') {
      running++
    } else if (status === 'stopped' || status === 'exited' || status === 'dead') {
      stopped++
    } else {
      other++
    }
  })

  return { running, stopped, other }
}

const getProjectStatusColor = (services) => {
  if (!services || services.length === 0) {
    return 'grey.400'
  }

  const { running, stopped, other } = countServicesByStatus(services)
  const total = services.length

  if (running === total) {
    return 'success.main'
  }
  if (stopped === total) {
    return 'error.main'
  }
  if (running > 0 || other > 0) {
    return 'warning.main'
  }
  return 'error.main'
}

function ProjectStatusIndicator({ services }) {
  return (
    <Box
      sx={{
        width: '2rem',
        height: '2rem',
        borderRadius: '50%',
        bgcolor: getProjectStatusColor(services),
      }}
    />
  )
}

export default ProjectStatusIndicator
